import { FileRotateLeftOutlineIcon } from './FileRotateLeftOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 7DC8418D-3AE2-4BC3-9A5B-068FE316D172
 * name file-rotate-left-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-rotate-left-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileRotateCcwOutlineIcon = FileRotateLeftOutlineIcon;
export default FileRotateCcwOutlineIcon